import React from 'react';
import { useState, useContext, useEffect } from 'react';
import PermissionsGate from '../../../api/PermissionsGate';
import { SCOPES } from '../../../config/permissions-map';
import { Unauthorized } from '../../Global/unauthorized';
import { PageTitle } from '../../../../_metronic/layout/core';
import * as Utilities from '../../../Components/Utils/Utils';
import * as Api from '../../../api/Api';
import { useGetToken } from '../../../Hooks/CustomHooks';
import Modal from 'react-bootstrap/Modal';
import { FeedbackContext } from "../../../Components/Context/FeedbackContext";
import * as KeyNames from '../../../api/KeyNames';
import { useQuery } from 'react-query';
import { Loading } from '../../../Components/Loading/Loading';
import { SessionContext } from '../../../Components/Context/SessionContext';
import { ErrorConnection } from "../../../Components/Error/Error";
import FormularioRegistroCierre from './FormularioRegistroCierre';
import UserIdAuthorized from '../../../api/UserIdAuthorized';
import moment from 'moment';

function RegistarCierreLocatario({ title }) {

    const [date, setDate] = useState(new Date());
    const [serviceDate, setServiceDate] = useState(null);
    let dateFormated = moment().format('DD/MM/YYYY')

    const tokenn = useGetToken();
    const { session, setSession } = useContext(SessionContext);
    const idLocatario = (localStorage.getItem('idLocatario')) ? localStorage.getItem('idLocatario') : session.idUsuarioLocatario
    const { feedbackContext, setFeedbackContext } = useContext(FeedbackContext);

    const [dataGetRegistrar, setDataGetRegistrar] = useState({
        "fechaPorRegistrar": "",
        "suministros": []
    })

    const [dataSetRegistrar, setDataSetRegistrar] = useState(null)


    let { data: data1, isLoading: isloading1, isError, error } = useQuery([KeyNames.SessionRespuesta,
    {
        api: "GetRegistrarCierreVentas_Locatario",
        idLocatario: idLocatario,
        token: tokenn
    }],
        async () => await Api.GetRegistrarCierreVentas_Locatario(
            {
                idLocatario: idLocatario,
                token: tokenn
            }
        ),
        {
            enabled: true
        });


    useEffect(() => {
        if (data1) {
            if (!data1.success)
                setFeedbackContext({ ...feedbackContext, showError: true, idError: data1.errorId });
            else {
                setDataGetRegistrar(data1.data);
                let suministrosTemp = [];
                data1.data.suministros.forEach(suministros => {
                    suministrosTemp.push(
                        {
                            "idSuministroPorLocatario": suministros.idSuministroPorLocatario,
                            "descripcion": suministros.descripcion,
                            "venta": 0,
                            "transacciones": 0
                        }
                    )
                });
                setServiceDate(moment(data1.data.fechaPorRegistrar, "DD/MM/YYYY"))
                setDataSetRegistrar(
                    {
                        "fechaRegistro": serviceDate < date ? data1.data.fechaPorRegistrar : dateFormated,
                        "suministros": suministrosTemp
                    }
                );
            }
        }
    }, [data1]);

    const [guardadoExitoso, setGuardadoExitoso] = useState(false);

    function guardadoExistosoModal() {
        setGuardadoExitoso(false);
        window.location.reload(false);
    }


    if (isloading1 || dataSetRegistrar == null) return (<Loading />)
    if (isError) return (<ErrorConnection error={error} />)
    return (
        <>
            <PermissionsGate RenderError={() => <Unauthorized />} scopes={[SCOPES.REGISTRAR_CIERRE_VENTA_LOCATARIO]} >
                <UserIdAuthorized>

                    <PageTitle>
                        {title}
                    </PageTitle>
                    {

                        (dataSetRegistrar.fechaRegistro && serviceDate < date) ?

                            <>
                                <div className='card'>
                                    <div className='card-body p-lg-17'>
                                        <div className='text-center'><h3 className="fs-2hx text-dark mb-5">Cierre de Ventas del {dataSetRegistrar.fechaRegistro.split('/')[0]} de {Utilities.monthFullNames[parseInt(dataSetRegistrar.fechaRegistro.split('/')[1]) - 1]}</h3></div>
                                        <div className='fs-5 fw-bold text-gray-600'>
                                            <p className="mb-8"> La información ingresada al Portal de Ventas debe ser veraz, estando Mall Aventura facultada para aplicar las penalidades que correspondan, según las NGA que formante parte integrante de los contratos.
                                            </p>
                                            <p className="mb-8"> La información proporcionada por los arrendatarios podrá estar sujeta a auditorías por parte de Mall Aventura S.A.
                                            </p>
                                            <p className="mb-8"> La facturación neta mensual deberá ingresarse en el Portal de Ventas diariamente y en los plazos establecidos en la cláusula sétima de las Normas Generales de Arrendamiento.
                                            </p>
                                        </div>
                                        <div className="card bg-light-blue">
                                            <div className="card-body">
                                                <div className="fs-2 fw-bold text-blue text-center">
                                                    Recuerde registrar sus cierres de venta del día a tiempo
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className='row mb-3 mt-4'>
                                    <FormularioRegistroCierre dataSetRegistrar={dataSetRegistrar} setGuardadoExitoso={setGuardadoExitoso}></FormularioRegistroCierre>
                                </div>

                            </>
                            :
                            <>
                                <div className="alert alert-icon alert-success border-success alert-dismissible">
                                    <span>Ya se realizó el registro del cierre de ventas del día de hoy.</span>
                                </div>
                            </>
                    }
                    <Modal
                        size="sm"
                        show={guardadoExitoso}
                        onHide={() => setGuardadoExitoso(false)}
                        aria-labelledby="contained-modal-title-vcenter"
                        centered
                        backdrop="static"
                    >
                        <Modal.Header>
                            <Modal.Title id="example-modal-sizes-title-sm" style={{ margin: 'auto' }}>
                                Guardado Exitoso
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Footer style={{ margin: 'auto' }}>
                            <button type="button" className="btn btn-primary" onClick={guardadoExistosoModal}>
                                Aceptar
                            </button>
                        </Modal.Footer>
                    </Modal>
                </UserIdAuthorized>
            </PermissionsGate>
        </>
    )
}

export default RegistarCierreLocatario;
